module.exports = __webpack_public_path__ + "img/201110-6.cbcde47f.png";